<template>
  <tr
    class="tab-row"
    :class="item.class"
  >
    <td
      class="tab-cell tab-label"
      :style="{width: labelWidth}"
    >
      <span>{{ item.name }}</span>
    </td>
    <td class="tab-cell td-all">
      <span
        :class="{selected: limit[item.prop] === (item.hasOwnProperty('selectedAll') ? item.selectedAll : -1)}"
        class="item-tab"
        @click="$emit('select-all')"
      >
        <span>{{ item.skyLabel || allSelected }}</span>
      </span>
    </td>
    <td
      class="tab-cont"
      :colspan="cp_colspan"
    >
      <div
        class="over-ul"
        :style="cp_style"
      >
        <ul class="item-tab-ul clear-fix">
          <li
            v-for="(tab, i) in item.tabs"
            :key="i"
            class="fl item-tab"
            :class="{selected: !(limit[item.prop] === (item.hasOwnProperty('selectedAll') ? item.selectedAll : -1)) && limit[item.prop].toString().split(',').includes(tab.value.toString())}"
            @click="$emit('select-tab', item, tab)"
          >
            <span>{{ tab.label }}</span>
          </li>
        </ul>
      </div>
    </td>
    <td style="width: 80px; height: 43px">
      <transition name="el-zoom-in-top">
        <el-button
          v-show="page.slideBtn"
          type="primary"
          size="mini"
          @click="page.view = !page.view"
        >
          {{ page.view && '收起' || '查看更多' }}
        </el-button>
      </transition>
    </td>
  </tr>
</template>

<script>
import { $debounce } from '@/lib/functional';
export default {
    name: 'ConditionRow',
    props: {
        item: {
            type: Object,
            required: true,
        },
        limit: {
            type: Object,
            required: true,
        },
        labelWidth: {
            type: String,
            default: '120px',
        },
        allSelected: {
            type: String,
            default: '全部',
        },
    },
    data () {
        return {
            ulRect: {
                height: '',
            },
            page: {
                slideBtn: false,
                view: false,
                count: 0,
            },
            onScroll: $debounce(this.fetchHeight, 400, 'fixed', true),
        };
    },
    computed: {
        cp_style () {
            return {
                height: (this.page.view && this.ulRect.height) || '43px',
            };
        },
        cp_colspan () {
            return this.item.class && this.item.class.includes('hidden-check') && 2 || 1;
        },
    },
    watch: {
        'item.tabs': {
            handler () {
                this.fetchHeight();
            },
            deep: true,
        },
    },
    mounted () {
        this.fetchHeight();
        window.addEventListener('resize', this.onScroll, false);
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.onScroll);
    },
    methods: {
        calcHeight (prev = -1) {
            let ul = this.$el.querySelector('.item-tab-ul'),
                verify = cb => {
                    let rect = ul.getBoundingClientRect();
                    if (parseInt(rect.height) !== prev) {
                        prev = parseInt(rect.height);
                        setTimeout(() => {
                            verify(cb);
                        }, 100);
                    } else if (prev === 0 && this.page.count < 20) {
                        setTimeout(() => {
                            this.page.count++;
                            verify(cb);
                        }, 100);
                    } else {
                        cb(rect, 1);
                    }
                };
            return new Promise(verify);
        },
        fetchHeight () {
            this.page.count = 0;
            this.calcHeight().then(rect => {
                Object.assign(this.ulRect, {
                    height: rect.height + 'px',
                });
                this.page.slideBtn = rect.height > 43;
                this.page.view = this.page.slideBtn && this.page.view;
            });
        },
    },
};
</script>

<style scoped lang="scss">
$trans: height 0.1s linear;
.over-ul {
  overflow: hidden;
  margin-bottom: -15px;
  -webkit-transition: $trans;
  -moz-transition: $trans;
  -ms-transition: $trans;
  -o-transition: $trans;
  transition: $trans;
}
</style>
